import React from 'react'

export default (
	<svg width='47' height='47' viewBox='0 0 42 42'>
		<defs>
			<linearGradient
				id='devops-a'
				x1='0%'
				x2='95.861%'
				y1='50%'
				y2='50%'
			>
				<stop offset='0%' stopColor='#7F66E0' />
				<stop offset='100%' stopColor='#5566E1' />
			</linearGradient>
		</defs>
		<g fill='none' fillRule='evenodd'>
			{/* <circle
				cx='21'
				cy='21'
				r='21'
				fill='url(#devops-a)'
				opacity='.4'
			/> */}
			<g transform='translate(5 5)'>
				<circle
					cx='16'
					cy='16'
					r='16'
					fill='url(#devops-a)'
				/>
				<path
					fill='#FFF'
					d='M19.8115023,11.5208855 L19.8115023,10.1468343 C19.8115023,9.81880165 19.4145459,9.65441676 19.1823431,9.88625106 L16.7549017,12.3136925 C16.6107884,12.4578057 16.6107884,12.6911143 16.7549017,12.8348589 L19.1823431,15.2623003 C19.4145459,15.4945032 19.8115023,15.3301183 19.8115023,15.0017171 L19.8115023,13.6317202 C21.347727,13.650149 22.5916709,14.9040445 22.5916709,16.4443235 C22.5916709,17.9963969 21.3289296,19.2591383 19.7768561,19.2591383 C18.2247827,19.2591383 16.9624099,17.9963969 16.9624099,16.4443235 C16.9624099,13.7282871 14.7527969,11.5190427 12.0367605,11.5190427 C9.32109269,11.5190427 7.11111111,13.7282871 7.11111111,16.4443235 C7.11111111,19.1411939 9.29013231,21.3356953 11.9792627,21.3670243 L11.9792627,22.7418127 C11.9792627,23.0702139 12.376219,23.2345988 12.6084219,23.0023959 L15.0358633,20.5749545 C15.1799765,20.4312099 15.1799765,20.1979013 15.0358633,20.0537881 L12.6084219,17.6263467 C12.376219,17.3945124 11.9792627,17.5588973 11.9792627,17.8869299 L11.9792627,19.2561896 C10.4540953,19.2252293 9.22231433,17.977231 9.22231433,16.4443235 C9.22231433,14.89225 10.4846871,13.6298773 12.0367605,13.6298773 C13.588834,13.6298773 14.8512067,14.89225 14.8512067,16.4443235 C14.8512067,19.1607285 17.0611883,21.3699729 19.7768561,21.3699729 C22.492524,21.3699729 24.7025055,19.1607285 24.7025055,16.4443235 C24.7025055,13.7400815 22.5113213,11.5396829 19.8115023,11.5208855'
				/>
			</g>
		</g>
	</svg>
)
